import ApiClient from './ApiClient';

class TicketFieldSettingsAPI extends ApiClient {
  constructor() {
    super('ticket_field_settings', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(field) {
    return axios.post(this.url, { field });
  }

  update(id, field) {
    return axios.patch(`${this.url}/${id}`, { field });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reorder(fields) {
    return axios.post(`${this.url}/reorder`, { fields });
  }
}

export default new TicketFieldSettingsAPI();
